import apiClient from './apiClient';

export const proaktiveAktionenApi = {
  // Alle offenen Aktionen laden
  getAktionen: (params = {}) =>
    apiClient.get('/proaktive-aktionen', { params }),

  // Statistiken laden
  getStats: () =>
    apiClient.get('/proaktive-aktionen/stats'),

  // Einzelne Aktion laden (mit Details)
  getAktion: (id) =>
    apiClient.get(`/proaktive-aktionen/${id}`),

  // Aktion als ausgeführt markieren
  ausfuehren: (id) =>
    apiClient.post(`/proaktive-aktionen/${id}/ausfuehren`),

  // Aktion ignorieren
  ignorieren: (id) =>
    apiClient.post(`/proaktive-aktionen/${id}/ignorieren`),

  // Aktion zurückstellen
  zurueckstellen: (id, bis) =>
    apiClient.post(`/proaktive-aktionen/${id}/zurueckstellen`, { bis }),

  // Einstellungen laden
  getEinstellungen: () =>
    apiClient.get('/proaktive-aktionen/einstellungen'),

  // Einstellungen speichern
  updateEinstellungen: (data) =>
    apiClient.put('/proaktive-aktionen/einstellungen', data),

  // Manuell generieren (Admin)
  manuellGenerieren: () =>
    apiClient.post('/proaktive-aktionen/generieren'),

  // Schnellaktion ausführen (E-Mail senden, Mahnung erstellen, etc.)
  schnellAktion: (id, data = {}) =>
    apiClient.post(`/proaktive-aktionen/${id}/schnellaktion`, data)
};

export default proaktiveAktionenApi;
